export default {
  SET_DISABLED_STATUS: '@WS_EDITOR/VIEW/SET_DISABLED_STATUS',
};
